import { QUOTE_REFETCH_INTERVAL_MS } from "../../config/consts";
import { useTimedQuoteRefetch } from "../../hooks/useTimedQuoteRefetch";
import "../../pages/Trade/index.css";
import { GlobalStore } from "../../store/global/GlobalStore";
import { useCanQuote } from "../../hooks/useCanQuote";
import { ExpiryTimer } from "./elements/ExpiryTimer";
import { AutoRefreshContainer } from "./elements/AutoRefreshContainer";
import { Spacer } from "../general/Spacer/Spacer";
import QuoteBar from "./QuoteBar";

export const QuoteExpiryBar: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const autoRefreshQuote = GlobalStore.useState(s => s.autoRefreshQuote);
  const { secondsToExpiry } = useTimedQuoteRefetch();
  const canQuote = useCanQuote();
  const intervalInSeconds = QUOTE_REFETCH_INTERVAL_MS / 1000;
  const progress = ((intervalInSeconds - secondsToExpiry) / intervalInSeconds) * 100;
  return (
    <div className={"mt-2"}>
      <div className={"row align-items-center"}>
        <div className={"col"}>
          <ExpiryTimer theme={theme}>
            {secondsToExpiry > 0 ? (
              <> Quote Expires in {secondsToExpiry} sec </>
            ) : (
              <> Quote Expired </>
            )}
          </ExpiryTimer>
        </div>
        <div className={"col"}>
          <AutoRefreshContainer theme={theme}>
            Auto Refresh
            <label className="switch mx-2">
              <input
                type="checkbox"
                className={"mx-2"}
                checked={autoRefreshQuote}
                onChange={e => {
                  GlobalStore.update(s => {
                    s.autoRefreshQuote = e.target.checked;
                  });
                }}
              />
              <span className="slider round" />
            </label>
          </AutoRefreshContainer>
        </div>
        <Spacer height={"10px"}></Spacer>
      </div>
      <QuoteBar progress={progress} isVisible={canQuote} />
    </div>
  );
};
